
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1A1A1A] text-white">
      <div className="px-4 md:px-8 lg:px-20 py-12 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row justify-between items-start mb-12 md:mb-16">
            <div className="mb-8 lg:mb-0">
              <div className="flex items-center gap-3 mb-4">
                <img 
                  src="https://public.readdy.ai/ai/img_res/95e9c46e-5455-4a4a-a610-9561bd551b4a.png" 
                  alt="Leachianus Logo" 
                  className="h-8 md:h-10 w-8 md:w-10 object-contain"
                />
                <span className="text-xl md:text-2xl font-semibold tracking-wide">LEACHIANUS</span>
              </div>
              <p className="text-gray-400 max-w-md">
                Your trusted source for Leachianus gecko information and care guidance
              </p>
            </div>
            <div className="text-left lg:text-right">
              <p className="font-serif italic text-base md:text-lg text-gray-300">
                Dedicated to the conservation and proper care of Rhacodactylus leachianus
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12 md:mb-16 pb-12 md:pb-16 border-b border-gray-700">
            <div>
              <h3 className="text-lg md:text-xl font-bold mb-4 md:mb-6">Explore</h3>
              <ul className="space-y-2 md:space-y-3">
                <li>
                  <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-[#B8E986] transition-colors cursor-pointer">
                    Species Overview
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('gallery')} className="text-gray-400 hover:text-[#B8E986] transition-colors cursor-pointer">
                    Morph Gallery
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('care')} className="text-gray-400 hover:text-[#B8E986] transition-colors cursor-pointer">
                    Care Requirements
                  </button>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-[#B8E986] transition-colors cursor-pointer">
                    Breeding Guide
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg md:text-xl font-bold mb-4 md:mb-6">Learn More</h3>
              <ul className="space-y-2 md:space-y-3">
                <li>
                  <button onClick={() => scrollToSection('habitat')} className="text-gray-400 hover:text-[#B8E986] transition-colors cursor-pointer">
                    Habitat Setup
                  </button>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-[#B8E986] transition-colors cursor-pointer">
                    Health & Wellness
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-[#B8E986] transition-colors cursor-pointer">
                    Feeding Schedule
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-[#B8E986] transition-colors cursor-pointer">
                    Common Questions
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg md:text-xl font-bold mb-4 md:mb-6">Connect</h3>
              <ul className="space-y-2 md:space-y-3">
                <li>
                  <a href="#" className="text-gray-400 hover:text-[#B8E986] transition-colors cursor-pointer">
                    Breeder Directory
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-[#B8E986] transition-colors cursor-pointer">
                    Forum Discussion
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-[#B8E986] transition-colors cursor-pointer">
                    Events Calendar
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-[#B8E986] transition-colors cursor-pointer">
                    Success Stories
                  </a>
                </li>
              </ul>
            </div>

            <div className="md:col-span-2 lg:col-span-1">
              <div className="font-serif text-xl md:text-2xl mb-2">© 2025</div>
              <div className="text-sm text-gray-400 mb-4 md:mb-6">All rights reserved</div>
              <div className="flex flex-wrap gap-3 md:gap-4">
                <a href="#" className="text-[#B8E986] hover:underline cursor-pointer">Instagram</a>
                <a href="#" className="text-[#B8E986] hover:underline cursor-pointer">Facebook</a>
                <a href="#" className="text-[#B8E986] hover:underline cursor-pointer">YouTube</a>
                <a href="#" className="text-[#B8E986] hover:underline cursor-pointer">Discord</a>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 items-center">
            <div className="order-2 md:order-1">
              <div className="rounded-2xl overflow-hidden shadow-lg border-2 border-[#B8E986]/30">
                <img
                  src="https://readdy.ai/api/search-image?query=leachianus%20gecko%20in%20naturalistic%20terrarium%20setup%20with%20plants%20and%20branches%20atmospheric%20lighting%20professional%20photography%20simple%20clean%20background&width=400&height=280&seq=footer-terrarium-015&orientation=landscape"
                  alt="Terrarium Setup"
                  className="w-full h-40 md:h-full object-cover"
                />
              </div>
            </div>

            <div className="text-center order-1 md:order-2">
              <h3 className="font-serif text-2xl md:text-3xl mb-3">Stay Updated</h3>
              <p className="text-gray-400 mb-4 md:mb-6">
                Get monthly care tips and updates delivered to your inbox
              </p>
              <form className="flex flex-col sm:flex-row gap-2" onSubmit={(e) => e.preventDefault()}>
                <input
                  type="email"
                  placeholder="Your email address"
                  className="flex-1 px-4 py-3 bg-transparent border-2 border-gray-600 rounded-xl focus:border-[#B8E986] focus:outline-none transition-colors"
                />
                <button className="bg-[#B8E986] text-gray-900 px-4 md:px-6 py-3 rounded-xl font-semibold hover:bg-[#a8d976] transition-colors flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer">
                  Subscribe
                  <i className="ri-arrow-right-line"></i>
                </button>
              </form>
            </div>

            <div className="text-center lg:text-right order-3">
              <p className="text-gray-400 mb-2">Questions? Email us at</p>
              <a href="mailto:info@leachianus.com" className="text-[#B8E986] text-base md:text-lg hover:underline cursor-pointer">
                info@leachianus.com
              </a>
              <p className="text-sm text-gray-500 mt-2">Response within 24 hours</p>
            </div>
          </div>

          <div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-gray-800 text-center">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-500 hover:text-[#B8E986] transition-colors text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
